import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

export const HeaderContainer = styled(Box)`
  background-color: var(--dk-bg, white);
  flex: none;
`;

export const SubHeader = styled(Box)`
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
  white-space: pre;
  padding: 24px 0 12px;
  border-bottom: 2px solid black;
  background-color: var(--dk-bg, white);
`;

export const SearchResultContainer = styled(Box)`
  min-width: 0;
  display: flex;
  flex: 1;

  font-size: 20px;
  font-weight: 700;
`;

export const BoldText = styled(Typography)`
  color: var(--dk-accent, #06c);
  font-size: inherit;
  font-weight: inherit;
`;
